module.exports = __webpack_public_path__ + "img/icon-none@3x.d269577e.png";